import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/Link';

import './index.scss';

const b = b_.with('breadcrumb');

export const Breadcrumb: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Link to="/investments" className={b()}>
      <span className={b('arrow')}>←</span> {t('All invest ideas')}
    </Link>
  );
};
